import React, {Component, ReactElement} from 'react'
import NatMessageRepo from '../message/repository/NatMessageRepo'
import {MessageInfo, NatGetMessage} from './repository/NatGetMessage'
import {Nullable} from '../../../app/TypeHelpers'
import {DisplayBlockDiv} from '../../../styledComponents/DisplayItem'
import {StyledSecondaryButton} from '../../../styledComponents/Button'
import {Box} from '@mui/material'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {NatAsyncCallFunction} from '../../common/util/Natutil'
import NatMessageForResidentComponent from './common/NatMessageForResidentComponent'
import {PlainBackLink} from '../../../styledComponents/Links'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {HttpError} from '../../../network/errors/HttpError'
import {HttpStatusCode} from '../../../network/Constants'
import {HAVE_OR_NOT, SET_EXISTENCE} from '../../../CodeMaster'
import {Location} from 'react-router-dom'

interface Props {
    messageId: string,
    messageRepo: NatMessageRepo,
    location: Location,
}

interface States {
    messageInfo: MessageInfo
    isLoadCompleted: boolean
}

class NatResidentMessagePage extends Component<Props & ResidentPagePropsSet, States> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            messageInfo: {
                messageId: 0,
                deliveryTargetPrefectureCd: '',
                deliveryTargetAddress2: '',
                messageNotDeliveryCondominium: [],
                condominiumGroupId: 0,
                condominiumGroupName: '',
                condominiumName: null,
                categoryId: '',
                publishStartDate: '',
                publishEndDate: '',
                title: '',
                description: '',
                topFixed: '',
                copyAvailability: '',
                version: 0,
                controlFlag: '',
                messageFile: [],
                doNotify: SET_EXISTENCE.NOT.value,
                notifiedFlag: HAVE_OR_NOT.NOT.value,
            },
            isLoadCompleted: false,
        }

        this.handleBackButtonClick = this.handleBackButtonClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // メッセージ取得
            const messageInfo: Nullable<NatGetMessage> = await NatAsyncCallFunction(
                this.props.messageRepo.getMessageForResident.bind(
                    this.props.messageRepo,
                    this.props.messageId), this.props.navigate)
            if (messageInfo && messageInfo.details !== null) {
                this.setState({messageInfo: messageInfo.details})
            }
        } catch (requestError) {
            if (requestError instanceof HttpError) {
                if (requestError.status === HttpStatusCode.CLIENT_ERROR) {
                    this.props.navigate(
                        `/resident/not-found`,
                        {
                            state: {
                                message: requestError.message,
                            },
                        },
                    )
                } else {
                    throw Error('通信エラー')
                }
            }
            return
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    handleBackButtonClick(): void {
        this.props.navigate(`/resident/messageList`)
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        let previousPageUrl: string = `/resident/messageList`
        if (this.props.location.state) {
            previousPageUrl = this.props.location.state.previousPageUrl
        }
        return (
            <>
                <PlainBackLink to={previousPageUrl}>戻る</PlainBackLink>
                <BlockSpacer height={'16px'}/>
                <NatMessageForResidentComponent
                    categoryId={this.state.messageInfo.categoryId}
                    publishStartDate={this.state.messageInfo.publishStartDate}
                    title={this.state.messageInfo.title}
                    description={this.state.messageInfo.description}
                    messageFile={this.state.messageInfo.messageFile}
                />
                <Box pt={'15px'}>
                    <DisplayBlockDiv>
                        <StyledSecondaryButton onClick={this.handleBackButtonClick}>一覧へ戻る</StyledSecondaryButton>
                    </DisplayBlockDiv>
                </Box>
            </>
        )
    }
}

export default createResidentPage(NatResidentMessagePage)
